import { Tag } from '@adminModels';
import { createAction, props } from '@ngrx/store';

export const ADMIN_TAGS_ID = '[Tags admin]';

export interface TagsQueryParams {
  page?: number;
  limit?: number;
  search?: string;
  isActive?: boolean;
  sortBy?: 'nameSk' | 'nameEn' | 'createdAt';
  sortOrder?: 'ASC' | 'DESC';
}

export const loadTags = createAction(
  ADMIN_TAGS_ID + ' Load Tags',
  props<{ params?: TagsQueryParams }>(),
);

export const loadTagsSuccess = createAction(
  ADMIN_TAGS_ID + ' Load Tags Success',
  props<{ tags: Tag[]; pagination: { total: number; page: number; limit: number; totalPages: number } }>(),
);

export const loadTagsFailure = createAction(
  ADMIN_TAGS_ID + ' Load Tags Failure',
  props<{ error: string }>(),
);

export const createTag = createAction(
  ADMIN_TAGS_ID + ' Create Tag',
  props<{ tagData: CreateTagData }>(),
);

export const createTagSuccess = createAction(
  ADMIN_TAGS_ID + ' Create Tag Success',
  props<{ tag: Tag }>(),
);

export const createTagFailure = createAction(
  ADMIN_TAGS_ID + ' Create Tag Failure',
  props<{ error: string }>(),
);

export const updateTag = createAction(
  ADMIN_TAGS_ID + ' Update Tag',
  props<{ id: string; tagData: UpdateTagData }>(),
);

export const updateTagSuccess = createAction(
  ADMIN_TAGS_ID + ' Update Tag Success',
  props<{ tag: Tag }>(),
);

export const updateTagFailure = createAction(
  ADMIN_TAGS_ID + ' Update Tag Failure',
  props<{ error: string }>(),
);

export const deleteTag = createAction(
  ADMIN_TAGS_ID + ' Delete Tag',
  props<{ id: string }>(),
);

export const deleteTagSuccess = createAction(
  ADMIN_TAGS_ID + ' Delete Tag Success',
  props<{ id: string }>(),
);

export const deleteTagFailure = createAction(
  ADMIN_TAGS_ID + ' Delete Tag Failure',
  props<{ error: string }>(),
);

export interface CreateTagData {
  name: {
    sk: string;
    en: string;
  };
}

export interface UpdateTagData {
  name?: {
    sk: string;
    en: string;
  };
}
